const DISMISSED_KEY = 'sc_popup_dismissed';
const SUBSCRIBED_KEY = 'sc_popup_subscribed';
const DISMISS_TTL = 30 * 24 * 60 * 60 * 1000;

function shouldSkip() {
  if (window.location.pathname === '/cart') return true;
  if (localStorage.getItem(SUBSCRIBED_KEY)) return true;
  const ts = localStorage.getItem(DISMISSED_KEY);
  if (ts && Date.now() - parseInt(ts) < DISMISS_TTL) return true;
  return false;
}

function copyToClipboard(text, btn) {
  const finish = () => {
    btn.textContent = 'Copied!';
    setTimeout(() => { btn.textContent = 'Copy'; }, 2000);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(finish).catch(() => fallbackCopy(text, finish));
  } else {
    fallbackCopy(text, finish);
  }
}

function fallbackCopy(text, onSuccess) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  try { document.execCommand('copy'); onSuccess(); } catch (_) {}
  document.body.removeChild(ta);
}

function init() {
  const overlay = document.getElementById('sc-email-popup-overlay');
  if (!overlay || shouldSkip()) return;

  const modal = overlay.querySelector('.sc-popup-modal');
  const closeBtn = document.getElementById('sc-popup-close');
  const form = document.getElementById('sc-email-popup-form');
  const copyBtn = document.getElementById('sc-popup-copy-btn');
  let shown = false;

  function show() {
    if (shown) return;
    shown = true;
    overlay.removeAttribute('aria-hidden');
    overlay.classList.add('is-open');
    document.body.classList.add('sc-popup-open');
    closeBtn?.focus();
  }

  function dismiss() {
    localStorage.setItem(DISMISSED_KEY, Date.now().toString());
    close();
  }

  function close() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('sc-popup-open');
  }

  function showSuccess() {
    document.getElementById('sc-popup-form-view')?.classList.add('hidden');
    document.getElementById('sc-popup-success-view')?.classList.remove('hidden');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    const action = (form.getAttribute('action') || window.location.pathname).split('#')[0];

    try {
      await fetch(action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        redirect: 'manual',
      });
    } catch (_) {
      // Show success optimistically regardless
    }

    localStorage.setItem(SUBSCRIBED_KEY, 'true');
    showSuccess();
  }

  closeBtn?.addEventListener('click', dismiss);
  overlay.addEventListener('click', (e) => {
    if (modal && !modal.contains(e.target)) dismiss();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) dismiss();
  });
  form?.addEventListener('submit', handleSubmit);
  copyBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    copyToClipboard('CADDIE20', copyBtn);
  });

  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  if (isMobile) {
    let triggered = false;
    window.addEventListener('scroll', () => {
      if (triggered) return;
      const depth = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (depth >= 0.6) { triggered = true; show(); }
    }, { passive: true });
  } else {
    document.documentElement.addEventListener('mouseleave', (e) => {
      if (e.clientY < 5) show();
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
